import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  ActiveUserProfilePromiseService,
  CcyPairPromiseLookupService,
  ClientPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  OpsIntTableDefinitionFactory,
} from "shared/cubiq-services";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import { RowNode } from "ag-grid-community";
import {
  BfxBlotterFilter,
  BfxBlotterFilterCondition,
} from "app/bfx-blotter-filter/bfx-blotter-filter.constants";
import { BfxBaseBlotterFilteringService } from "../../bfx-base-blotter/bfx-base-blotter-filtering.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxBlotterOpsIntFilterService extends BfxBaseBlotterFilteringService {
  public updateFilterDataCallback: any;
  private selectedFilters: Array<BfxBlotterFilter> = [];

  constructor(
    protected tableDefinitionFactory: OpsIntTableDefinitionFactory,
    protected activeUserService: ActiveUserProfilePromiseService,
    protected clientService: ClientPromiseLookupService,
    protected currencyPairService: CcyPairPromiseLookupService,
    protected currencyPairGroupService: CurrencyPairGroupPromiseLookupService,
  ) {
    super(
      tableDefinitionFactory,
      activeUserService,
      clientService,
      currencyPairService,
      currencyPairGroupService,
    );
  }

  public checkEventCategory(rowData: RowNode | CubiqTS.OpsIntEventImpl): string {
    try {
      const opsIntEvent: CubiqTS.OpsIntEventImpl =
        rowData instanceof RowNode ? rowData.data : rowData;
      let column: BfxColDef = this.columns["category"];
      if (column == null) {
        return null;
      }
      let value;
      if (
        column.valueGetter != null &&
        (rowData instanceof CubiqTS.OpsIntEventImpl || rowData instanceof RowNode)
      ) {
        let data: any = rowData;
        let getter: Function = column.valueGetter as Function;
        value = getter(data);
      }
      return value;
    } catch (error) {
      logger.out.error(
        `Error: Failed property check: ${this.constructor.name} at checkEventCategory: ${error.message}`,
      );
    }
  }

  public doFiltersPass(rowData: RowNode): boolean {
    for (let i: number = 0; i < this.selectedFilters.length; i++) {
      if (this.doesFilterPass(rowData, this.selectedFilters[i])) {
        return true;
      }
    }
    return false;
  }

  public doesFilterPass(rowData: RowNode, filter: BfxBlotterFilter): boolean {
    for (let i = 0; i < filter.conditions.length; i++) {
      if (!this.checkCondition(rowData, filter.conditions[i])) {
        return false;
      }
    }
    return true;
  }

  private checkCondition(
    rowData: RowNode | CubiqTS.OpsIntEventImpl,
    condition: BfxBlotterFilterCondition,
  ): boolean {
    let column: BfxColDef = this.columns[condition.fieldName];
    if (column == null) {
      return true;
    }
    let orderValues = this.processRowDataValues(rowData, column);
    let filterValues = this.processFilterValues(condition);

    switch (condition.operatorData.value) {
      case CubiqTS.Operator.In:
        return filterValues.some((val) => orderValues.indexOf(val) >= 0);
      default:
        return false;
    }
  }

  private processRowDataValues(
    rowData: RowNode | CubiqTS.OpsIntEventImpl,
    column: BfxColDef,
  ): Array<any> {
    let orderValues = [];
    let value =
      rowData instanceof RowNode
        ? rowData.data.info.opsException[column.field]
        : rowData.info.opsException[column.field];
    if (
      column.valueGetter != null &&
      (rowData instanceof CubiqTS.OpsIntEventImpl || rowData instanceof RowNode)
    ) {
      let data: any = rowData;
      let getter: Function = column.valueGetter as Function;
      value = getter(data);
    }
    orderValues.push(value);
    return orderValues;
  }

  private processFilterValues(condition: BfxBlotterFilterCondition): Array<any> {
    let values = [];
    values.push(condition.value);
    return values;
  }

  public setSelectedFilters(selectedFilters: Array<BfxBlotterFilter>): void {
    this.selectedFilters = selectedFilters;
    if (this.updateFilterDataCallback != null) {
      this.updateFilterDataCallback();
    }
  }
}
